import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

export const fetchColor = createAsyncThunk('colorSlice/fetchColor', async () => {
    const res = await fetch(`${process.env.REACT_APP_PROJECTS_API}components/s_d.php?color`)
    const data = await res.json()
    return data;
})

const colorSlice = createSlice({
    initialState: {
        color: [],
        loading: false,
        error: null,
    },
    name: 'colorSlice',
    extraReducers: (builder) => {
        builder
            .addCase(fetchColor.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchColor.fulfilled, (state, action) => {
                state.loading = false;
                state.color = action.payload;
            })
            .addCase(fetchColor.rejected, (state, action) => {
                state.loading = false;
                state.error = <p className='error-api'>The server is temporarily down Please try later!</p>;
            });
    },
})

export const { } = colorSlice.actions;

export default colorSlice.reducer;